<bricks-card>
  <div class="card-custom">
    <div class="card-custom__item">
      <h3>
        <span>Projektname</span>
        <app-tooltip
          text="Wählen Sie einen Titel, der für Sie Sinn ergibt – z. B. Standort, Ressourcengruppe oder Einsatzbereich. Der Projekttitel hilft Ihnen dabei, Angebote bei mehreren Einträgen schnell wiederzufinden." />
      </h3>

      <div class="flex-row">
        <div class="flex-col-50">
          <bricks-input
            [showResetOption]="true"
            [placeholder]="'z. B. Anlage 01'"
            [label]="'Projektname'"
            [formControl]="formGroup.controls.locationNameCustomer"
            width="fill">
            @if (formGroup.controls.locationNameCustomer.hasError('maxlength')) {
              <bricks-error>
                Es sind maximal
                {{ formGroup.controls.locationNameCustomer.errors?.['maxlength']?.requiredLength }}
                Zeichen erlaubt.
              </bricks-error>
            }
          </bricks-input>
        </div>
      </div>
    </div>
  </div>
</bricks-card>
<bricks-card>
  <div class="card-custom">
    <div class="card-custom__item">
      <h3>
        <span>
          Erzeugungstechnologie
          <app-required-asterisk />
        </span>
      </h3>
      @for (option of PRODUCTION_TECHNOLOGY_OPTIONS; track option) {
        <div>
          <input
            [id]="`radio-production-technology-${option.value}`"
            class="bricks-input"
            type="radio"
            name="productionTechnology"
            [formControl]="formGroup.controls.productionTechnology"
            [value]="option.value"
            [class.error]="
              formGroup.controls.productionTechnology.hasError('required') &&
              formGroup.controls.productionTechnology.touched
            " />
          <label [for]="`radio-production-technology-${option.value}`" class="density">
            {{ option.label }}
          </label>
        </div>
      }
    </div>
    <div class="card-custom__item">
      <h3>
        <span>
          Wurde die Anlage bereits in Betrieb genommen?
          <app-required-asterisk />
        </span>
        <app-tooltip
          text="Wir beziehen uns auf die Definition gemäß Marktstammdatenregister, nach der die erstmalige Inbetriebnahme erfolgt ist." />
      </h3>
      @for (option of isAlreadyInOperationOptions; track option) {
        <div>
          <input
            [id]="`radio-is-already-in-operation-${option.value}`"
            class="bricks-input"
            type="radio"
            name="isAlreadyInOperation"
            [formControl]="formGroup.controls.isAlreadyInOperation"
            [value]="option.value"
            [class.error]="
              formGroup.controls.isAlreadyInOperation.hasError('required') &&
              formGroup.controls.isAlreadyInOperation.touched
            " />
          <label [for]="`radio-is-already-in-operation-${option.value}`" class="density">
            {{ option.label }}
          </label>
        </div>
      }
    </div>
    <div class="card-custom__item">
      <h3>
        <span>
          Bitte wählen Sie die gewünschte Direktvermarktungsform
          <app-required-asterisk />
        </span>
        <bricks-icon color="primary" height="24px" width="24px" class="tooltip-overlay__icon" (click)="openOverlay()">
          bricks-help
        </bricks-icon>
      </h3>
      @for (option of MARKETING_TYPE_OPTIONS; track option) {
        <div>
          <input
            [id]="`radio-marketing-type-${option.value}`"
            class="bricks-input"
            type="radio"
            name="marketingType"
            [formControl]="formGroup.controls.marketingType"
            [value]="option.value"
            [class.error]="
              formGroup.controls.marketingType.hasError('required') && formGroup.controls.marketingType.touched
            " />
          <label [for]="`radio-marketing-type-${option.value}`" class="density">
            {{ option.label }}
          </label>
        </div>
      }
    </div>
    <div class="card-custom__item">
      <h3>
        <span>Vertragslaufzeit</span>
      </h3>
      <div class="flex-row">
        <div class="flex-col-50">
          <div class="dropdown-tooltip-row">
            <bricks-input-dropdown
              [showResetOption]="true"
              id="contractStartDate"
              label="Gewünschter Direktvermarktungs-Start"
              [formControl]="formGroup.controls.contractStartDate">
              @for (date of validStartDates(); track date) {
                <bricks-option [value]="date">
                  {{ date | dateDayMonthYear }}
                </bricks-option>
              }
            </bricks-input-dropdown>
            <app-tooltip
              text="Verträge beginnen immer nur zum Monatsersten. Das Datum muss min. 6 Wochen und max. 6 Monate in der Zukunft liegen." />
          </div>
        </div>

        <div class="flex-col-50">
          <div class="dropdown-tooltip-row">
            <bricks-input-dropdown
              [showResetOption]="true"
              id="contractEndDate"
              label="Gewünschtes Vertragsende"
              [formControl]="formGroup.controls.contractEndDate">
              @for (date of validEndDates(); track date) {
                <bricks-option [value]="date">
                  {{ date | dateDayMonthYear }}
                </bricks-option>
              }
            </bricks-input-dropdown>
            @if (formGroup.controls.isAlreadyInOperation.value === null) {
              <app-tooltip
                text="Bitte geben Sie zuerst an, ob die Anlage bereits in Betrieb genommen wurde und wählen Sie den gewünschten Direktvermarktungs-Start aus." />
            }
            @if (formGroup.controls.isAlreadyInOperation.value === false) {
              <app-tooltip
                text="Verträge enden immer zum 31.12. eines Jahres. Die initiale Laufzeit liegt zwischen 16 und 29 Monaten und kann verlängert werden" />
            }
            @if (formGroup.controls.isAlreadyInOperation.value === true) {
              <app-tooltip
                text="Verträge enden immer zum 31.12. eines Jahres. Die initiale Laufzeit liegt zwischen 12 und 24 Monaten und kann verlängert werden" />
            }
          </div>
        </div>
      </div>
    </div>
  </div>
</bricks-card>
